import React, { useRef } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ImagePopupContainer from '../common/popup/ImagePopupContainer';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
};

const StyleFabricDetailComponent = props => {
    const { info,
        detailMode, movieUrl,
        isShowImagePopup, selectedImageIdx,
        onMouseOverItem, onClickBtnMovie,
        onClickBtnMobileMovie, mobileMovieUrl, onEndedMobileVideo, onPauseMobileVideo,
        onClickBtnShowImagePopup, onClickBtnCloseImagePopup,
        onClickBtnThumbnail } = props;
    return (
        <main className="style-fabric-view">
            <div className="body">
                <section className="col">
                    <div className='images-mb'>
                        <Slider
                            className='slider'
                            {...settings}>
                            {info.imageUrlList.map((imageUrl, idx) =>
                                <div
                                    className={`${selectedImageIdx === idx ? 'on' : ''}`}
                                    onClick={evt => onClickBtnThumbnail(idx)}
                                    key={idx}>
                                    <div className="img">
                                        <img
                                            src={imageUrl}
                                            alt={info.name}
                                        />
                                    </div>
                                </div>
                            )}
                        </Slider>
                        {info.movieObj ?
                            <div class='control'>
                                <a onClick={evt => onClickBtnMobileMovie(info.movieObj.url)} class='btn-play-video'>
                                    VIEW VIDEO
                                <i></i>
                                </a>
                            </div>
                            : null}
                        {mobileMovieUrl ?
                            <div class='mobile-movie-popup'>
                                <video muted autoPlay controls
                                    // onPause 현재 일시정지해도 재생 중지
                                    onPause={onPauseMobileVideo}
                                    onEnded={onEndedMobileVideo}
                                    src={mobileMovieUrl} />
                            </div>
                            : null}
                    </div>
                    <div className="images">
                        {detailMode === 'image' ?
                            <div
                                onClick={onClickBtnShowImagePopup}
                                className="full-img">
                                <img
                                    src={info.imageUrlList[selectedImageIdx]}
                                    alt={info.name}
                                />

                            </div>
                            :
                            <div
                                className='full-movie'>
                                <video src={movieUrl}
                                    autoPlay={true} loop={true} controls={true} muted={true}>
                                </video>
                            </div>
                        }
                        <div className="thumbnails">
                            <ul>
                                {info.imageUrlList.map((imageUrl, idx) =>
                                    <li
                                        className={`${selectedImageIdx === idx ? 'on' : ''}`}
                                        onMouseOver={evt => onMouseOverItem(idx)}
                                        key={idx}>
                                        <div className="img">
                                            <img
                                                src={imageUrl}
                                                alt={info.name}
                                            />
                                        </div>
                                    </li>
                                )}
                                {info.movieObj ?
                                    <li
                                        className='movie'
                                        onClick={evt => onClickBtnMovie(info.movieObj.url)}>
                                        <div className='img'>
                                            <img
                                                src={info.imageObj.url}
                                                alt={info.name} />
                                            <div className='mask'>
                                                <i></i>
                                            </div>
                                        </div>
                                    </li>
                                    : null}
                            </ul>
                        </div>
                    </div>
                </section>
                <section className="col">
                    <div className="info">
                        <h3>{info.name}</h3>
                        <div className="item-list">
                            <ul>
                                <li>
                                    <dl>
                                        <dt>FABRIC #</dt>
                                        <dd>{info.fabric}</dd>
                                    </dl>
                                    <dl>
                                        <dt>COLOR</dt>
                                        <dd>{info.color}</dd>
                                    </dl>
                                    {
                                        info.content ?
                                            <dl>
                                                <dt>CONTENT</dt>
                                                <dd>{info.content}</dd>
                                            </dl>
                                            : null
                                    }
                                    <dl>
                                        <dt>WEIGHT</dt>
                                        <dd>{info.weight}</dd>
                                    </dl>
                                    <dl>
                                        <dt>TWILL</dt>
                                        <dd>{info.twill}</dd>
                                    </dl>
                                    <dl>
                                        <dt>STRETCH LEVEL</dt>
                                        <dd>{info.stretchLevel}</dd>
                                    </dl>
                                    <dl>
                                        <dt>DYE STUFF</dt>
                                        <dd>{info.dyeStuff}</dd>
                                    </dl>
                                    <dl className="features">
                                        <dt>FEATURES</dt>
                                        <dd>
                                            {info.features.map((feature, idx) =>
                                                <div>{feature}</div>
                                            )}
                                        </dd>
                                    </dl>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="wrapper">
                            <ul className="sns">
                                <li>
                                    <a
                                        className="home"
                                        href="http://www.tcedenim.com/"
                                        target="_blank"
                                    >
                                        <i></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="facebook"
                                        href="https://www.facebook.com/TCEdenimstory/"
                                        target="_blank"
                                    >
                                        <i></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="youtube"
                                        href="https://www.youtube.com/channel/UCXpRK4O2lJ9XaG9c-uQccPg"
                                        target="_blank"
                                    >
                                        <i></i>
                                    </a>
                                </li>
                            </ul>
                            <div className="etc">
                                <ul className="lang">
                                    <li className="en">
                                        <a className="on" href="#"
                                        >ENGLISH</a>
                                    </li>
                                    <li className="ko">
                                        <a className="" href="#">KOREAN</a>
                                    </li>
                                </ul>
                                <div className="copyright">
                                    Copyright &copy;TCE. All rights
                                    reserved.
                                        </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <ImagePopupContainer
                info={info}
                selectedImageIdx={selectedImageIdx}
                isShowImagePopup={isShowImagePopup}
                onClickBtnCloseImagePopup={onClickBtnCloseImagePopup} />
        </main>
    )
}

export default StyleFabricDetailComponent;